export function PixelMark({ compact = false }: { compact?: boolean }) {
  return <div className="brand-mark"><span className="mark-glyph" aria-hidden="true"><i /><i /><i /><i /><i /></span>{!compact && <span><strong>nehalxaman</strong><small>PRIVATE WORLD / 02 PLAYERS</small></span>}</div>;
}
